// Helper function to get the current host i.e. send requests to localhost:8000 without /booking/
import { checkIsWebView } from '@camelot/webview-utils'

export default function getCurrentHost() {
  if (typeof window !== 'undefined') {
    return window.location.origin
  }
}

export function getAppPlatform(window: Window): string {
  if (checkIsWebView(window, 'webkit')) {
    return 'iOS'
  }
  else if (checkIsWebView(window, 'android')) {
    return 'android'
  }
  else {
    return 'web'
  }
}
